import { render, staticRenderFns } from "./form-tags.vue?vue&type=template&id=2585465e&scoped=true&"
import script from "./form-tags.vue?vue&type=script&lang=js&"
export * from "./form-tags.vue?vue&type=script&lang=js&"
import style0 from "./form-tags.vue?vue&type=style&index=0&id=2585465e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2585465e",
  null
  
)

export default component.exports